import PauseForm from './PauseForm.container'
import IconPause from 'components/Icons/Pause'
import PauseDisplay from './PauseDisplay'

export default {
  id: 'pause',
  label: 'Pause',
  helpUrl: 'https://help.thinkpickle.com.au/flows/actions/pause',
  icon: IconPause,
  inputs: [{}],
  outputs: [{}],
  display: PauseDisplay,
  form: PauseForm,
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/Pause/index.js